import * as yup from 'yup';

export const schema = yup
  .object({
    des_info_nutricional: yup.string().trim().required(),
  })
  .required();
